<!-- filters -->
<div class="aca-mig__toolbar">
  <input
    class="aca-mig__input"
    type="search"
    style="min-width: 220px"
    [(ngModel)]="search"
    [placeholder]="'DMS.MIGRATION.HIST_SEARCH' | translate"
    [attr.aria-label]="'DMS.MIGRATION.HIST_SEARCH' | translate"
  />
  <select class="aca-mig__select" [(ngModel)]="statusFilter">
    <option value="">{{ 'DMS.MIGRATION.HIST_ALL_STATUS' | translate }}</option>
    <option *ngFor="let s of statuses" [value]="s">{{ 'DMS.MIGRATION.ST_' + s.toUpperCase().replace('-', '_') | translate }}</option>
  </select>
  <select class="aca-mig__select" [(ngModel)]="connectorFilter">
    <option value="">{{ 'DMS.MIGRATION.HIST_ALL_SOURCES' | translate }}</option>
    <option *ngFor="let c of connectorsInUse()" [value]="c">{{ connectorName(c) }}</option>
  </select>
  <aca-date-input class="aca-mig__input" [(ngModel)]="dateFrom" />
  <aca-date-input class="aca-mig__input" [(ngModel)]="dateTo" />
</div>

<section class="aca-mig__card">
  <h3 class="aca-mig__cardtitle">{{ 'DMS.MIGRATION.TAB_HISTORY' | translate }}</h3>

  <div class="aca-mig__empty" *ngIf="!loading && !filtered().length">
    <mat-icon>history</mat-icon>
    <div class="aca-mig__emptytitle">{{ 'DMS.MIGRATION.EMPTY_HIST_TITLE' | translate }}</div>
  </div>

  <div class="aca-mig__tablewrap" *ngIf="filtered().length">
    <table class="aca-mig__table">
      <thead>
        <tr>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_JOB' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_MIGRATION' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_SOURCE' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DOCS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STARTED' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_COMPLETED' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_CREATED_BY' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let j of filtered(); trackBy: trackById">
          <td class="aca-mig__td aca-mig__mono">{{ j.id?.slice(0, 8) || '—' }}</td>
          <td class="aca-mig__td">{{ j.name }}</td>
          <td class="aca-mig__td">{{ connectorName(j.sourceConnector) }}</td>
          <td class="aca-mig__td">{{ j.statistics?.documents?.toLocaleString() ?? '—' }}</td>
          <td class="aca-mig__td">
            <span class="aca-mig__chip">{{ statusKey(j.status) | translate }}</span>
          </td>
          <td class="aca-mig__td">{{ dateLabel(j.startedAt) }}</td>
          <td class="aca-mig__td">{{ dateLabel(j.completedAt) }}</td>
          <td class="aca-mig__td">{{ j.createdBy || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<!-- audit trail -->
<section class="aca-mig__card">
  <h3 class="aca-mig__cardtitle">{{ 'DMS.MIGRATION.AUDIT_TITLE' | translate }}</h3>
  <p class="aca-mig__cardnote">{{ 'DMS.MIGRATION.AUDIT_NOTE' | translate }}</p>

  <div class="aca-mig__empty" *ngIf="!loading && !audit().length" style="padding: 24px">
    <mat-icon>fact_check</mat-icon>
    <div>{{ 'DMS.MIGRATION.AUDIT_EMPTY' | translate }}</div>
  </div>

  <div class="aca-mig__tablewrap" *ngIf="audit().length">
    <table class="aca-mig__table">
      <thead>
        <tr>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.AUDIT_WHEN' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.AUDIT_USER' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.AUDIT_ACTION' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.AUDIT_TARGET' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.AUDIT_DETAIL' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let e of audit(); trackBy: trackByAudit">
          <td class="aca-mig__td">{{ dateLabel(e.at) }}</td>
          <td class="aca-mig__td">{{ e.user }}</td>
          <td class="aca-mig__td aca-mig__mono">{{ e.action }}</td>
          <td class="aca-mig__td aca-mig__mono">{{ e.jobId || e.connectionId || '—' }}</td>
          <td class="aca-mig__td aca-mig__td--wrap">{{ e.detail || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
